'use client';

import Icon from '@/components/ui/AppIcon';

interface StatsProps {
  stats: {
    total: number;
    new: number;
    contacted: number;
    quoted: number;
    booked: number;
    cancelled: number;
    directBookings: number;
    leadInquiries: number;
    totalRevenue: number;
    pendingPayments: number;
  };
}

const LeadStats = ({ stats }: StatsProps) => {
  const statCards = [
    {
      label: 'Total Inquiries',
      value: stats.total,
      icon: 'UsersIcon' as const,
      color: 'from-blue-500 to-blue-600',
      textColor: 'text-blue-600',
    },
    {
      label: 'Direct Bookings',
      value: stats.directBookings,
      icon: 'CreditCardIcon' as const,
      color: 'from-green-500 to-green-600',
      textColor: 'text-green-600',
    },
    {
      label: 'Lead Inquiries',
      value: stats.leadInquiries,
      icon: 'ChatBubbleLeftRightIcon' as const,
      color: 'from-purple-500 to-purple-600',
      textColor: 'text-purple-600',
    },
    {
      label: 'New Leads',
      value: stats.new,
      icon: 'BellAlertIcon' as const,
      color: 'from-orange-500 to-orange-600',
      textColor: 'text-orange-600',
    },
    {
      label: 'Booked',
      value: stats.booked,
      icon: 'CheckCircleIcon' as const,
      color: 'from-green-500 to-green-600',
      textColor: 'text-green-600',
    },
    {
      label: 'Total Revenue',
      value: `£${stats.totalRevenue.toLocaleString()}`,
      icon: 'CurrencyPoundIcon' as const,
      color: 'from-primary to-secondary',
      textColor: 'text-primary',
    },
    {
      label: 'Pending Payments',
      value: `£${stats.pendingPayments.toLocaleString()}`,
      icon: 'ClockIcon' as const,
      color: 'from-yellow-500 to-yellow-600',
      textColor: 'text-yellow-600',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statCards.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-xl p-4 shadow-lg border-2 border-accent/20 hover:shadow-xl transition-all duration-300"
        >
          <div className={`w-10 h-10 bg-gradient-to-br ${stat.color} rounded-lg flex items-center justify-center mb-3`}>
            <Icon name={stat.icon as any} size={20} className="text-white" />
          </div>
          <p className="text-2xl font-heading font-black text-foreground mb-1">
            {stat.value}
          </p>
          <p className={`text-xs text-muted-foreground font-bold ${stat.textColor}`}>
            {stat.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default LeadStats;